import gql from 'graphql-tag';

export default gql`
  query ContactUs($contactUsId: ID!) {
    contactUs(id: $contactUsId) {
      id
      createdAt
      updatedAt
      name
      number
      email
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetContactUs.ts